import React from 'react';

import * as M from 'styles/mobile';
import useStatistics from '../useStatistics';

function Participation() {
  const {
    enrollCount,
    cancelCount,
    feedbackCount,
    lateOrAbsentCount,
    detailItems,
  } = useStatistics();

  const rows: [string, number][] = [
    ['신청인원', enrollCount],
    ['취소인원', cancelCount],
    ['피드백 작성 인원', feedbackCount],
    ['지각/노쇼', lateOrAbsentCount],
  ];

  return (
    <div css={M.section}>
      <div css={M.card}>
        <dl css={M.infoList}>
          {rows.map(([label, count]) => (
            <div key={label} css={M.infoRow}>
              <dt>{label}</dt>
              <dd>{count}명</dd>
            </div>
          ))}
        </dl>
      </div>
      {detailItems.length > 0 && (
        <div css={M.card}>
          <div css={M.cardHeader}>신청상세정보</div>
          <dl css={M.infoList}>
            {detailItems.map(({ label, count }, i) => (
              <div key={`${label}-${i}`} css={M.infoRow}>
                <dt>{label}</dt>
                <dd>{count}명</dd>
              </div>
            ))}
          </dl>
        </div>
      )}
    </div>
  );
}

export default Participation;
